import { GetAuthTokenResponse } from 'application-types';
import { request, Res } from './common';

export interface ListParams {
  building_id: string;
}

export interface ListResData {
  count: number;
  results: Space[];
}

export interface Space {
  id: string;
  floor_id: string;
  name: string;
  tenant_id: string;
}

export async function list(
  token: string,
  params: ListParams,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<Res<ListResData>> {
  return request({
    token,
    method: 'get',
    path: `/buildings/${params.building_id}/spaces?limit=1000`,
    getAuthToken: options?.getAuthToken,
    enableTokenManagement: options?.enableTokenManagement,
    channelIntegrationId: options?.channelIntegrationId,
  });
}
